import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { IconBolt, IconWorld, IconShield, IconCurrencyDollar, IconCurrencyDollarCanadian } from '@tabler/icons-react';

const Aboutwhychoose = () => {
  return (
    <>
      <section className="whychoose">
        <Container>
          <Row className='justify-content-center'>
            <Col md={8}>
              <div className="head-title">
                <div className="sup">Features</div>
                <h2>Why Choose <span className='text-gradient'>MyFX.ca?</span></h2>
                <p className='mt-2'>Whether you're managing international trade, paying for services, or sending money to loved ones abroad, MyFX.ca makes cross-border payments simple, reliable, and cost-effective</p>
              </div>
            </Col>
          </Row>
          <Row className='justify-content-center'>
            <Col lg={3} md={6} className='mb-4'>
              <div className="box">
                <div className="icon"><IconBolt size={24} strock={2} /></div>
                <span>Speed</span>
                <h3>Fast and Reliable</h3>
                <p>We provide efficient solutions for all your international payment needs.</p>
              </div>
            </Col>
            <Col lg={5} md={6} className='mb-4'>
              <div className="box">
                <div className="icon"><IconShield size={24} strock={2} /></div>
                <span>Compliance</span>
                <h3>Security and Transparency</h3>
                <p>We prioritize your peace of mind with secure transactions and transparent fees.</p>
              </div>
            </Col>
            <Col lg={3} md={6} className='mb-4'>
              <div className="box">
                <div className="icon"><IconWorld size={24} strock={2} /></div>
                <span>Network</span>
                <h3>Global Reach</h3>
                <p>Send money to countries across North America, Latin America, Asia, and Africa with ease.</p>
              </div>
            </Col>
            <Col lg={4} md={6} className='mb-4'>
              <div className="box">
                <div className="icon"><IconCurrencyDollar size={24} strock={2} /></div>
                <span>Affordability</span>
                <h3>Competitive Rates</h3>
                <p>Get the best value with our competitive exchange rates.</p>
              </div>
            </Col>
            <Col lg={4} md={12} className='mb-4'>
              <div className="box">
                <div className="icon"><IconCurrencyDollarCanadian size={24} strock={2} /></div>
                <span>FINTRAC</span>
                <h3>FINTRAC Registered</h3>
                <p>We are fully regulated by FINTRAC to ensure your safety and compliance.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Aboutwhychoose